import { Observable } from 'rxjs';
import { Injectable, TransferState, inject } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { ServiceResult } from '@shared/helper/service-result';
import { AddedBookDetailModel, BookModel, IAddedBookResponse, UpdateBookResult } from '@shared/model/bookModels/book-model';
import { AddedBookModel } from './../../model/added-book-model';
import { TServiceResult } from './../../helper/t-service-result';
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpBaseService } from '../base_services/http_base.service';
import { workItemRateModel } from '@shared/model/rateModels/rate-model';
import { transferBookModel } from '@shared/model/bookModels/book-model';
import { PageList } from './../../model/categoryAndSearch/pageList-model';
import { AuthorAggrigatorModel } from '@shared/model/authorAggrigator-model';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { SearchFilterModel } from '@shared/model/categoryAndSearch/search-filter-model';
import { BookRequestModel } from '@shared/model/bookModels/book-request.model';

@Injectable({
  providedIn: "root"
})
export class BookAggrigatorService extends HttpBaseService {
  private serverState = inject(TransferState);


  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'v1/bAggr');
  }

  getBookById(id: string): Observable<TServiceResult<BookModel>> {
    return this.http.get<TServiceResult<BookModel>>(`${this.apiUrl}/Get/${id}`);
  }

  getAuthorByBookId(bookId: string, TF?: TermFilterModel): Observable<TServiceResult<PageList<AuthorAggrigatorModel>>> {
    let paramsValues = '';
    if (TF?.pgNumber || TF?.pgNumber == 0)
      paramsValues = `?PgNumber=${TF?.pgNumber}`;
    if (TF?.pgSize)
      paramsValues = `?PgSize=${TF?.pgSize}`;
    if ((TF?.pgNumber || TF?.pgNumber == 0) && TF?.pgSize)
      paramsValues = `?PgNumber=${TF?.pgNumber}&PgSize=${TF?.pgSize}`;
    return this.http.get<TServiceResult<PageList<AuthorAggrigatorModel>>>(`${this.apiUrl}/GetAuthorByBookId/${bookId}${paramsValues}`);
  }

  getAuthorByBookIdGuest(bookId: string, TF?: TermFilterModel): Observable<TServiceResult<PageList<AuthorAggrigatorModel>>> {
    let paramsValues = '';
    if (TF?.pgNumber || TF?.pgNumber == 0)
      paramsValues = `?PgNumber=${TF?.pgNumber}`;
    if (TF?.pgSize)
      paramsValues = `?PgSize=${TF?.pgSize}`;
    if ((TF?.pgNumber || TF?.pgNumber == 0) && TF?.pgSize)
      paramsValues = `?PgNumber=${TF?.pgNumber}&PgSize=${TF?.pgSize}`;
    return this.http.get<TServiceResult<PageList<AuthorAggrigatorModel>>>(`${this.apiUrl}/GetAuthorByBookIdGuest/${bookId}${paramsValues}`);
  }

  getUserAddedBooks(TF?: TermFilterModel): Observable<TServiceResult<PageList<AddedBookModel>>> {
    let paramsValues = '';
    if (TF?.pgNumber || TF?.pgNumber == 0)
      paramsValues = `?PgNumber=${TF?.pgNumber}`;
    if (TF?.pgSize)
      paramsValues = `?PgSize=${TF?.pgSize}`;
    if ((TF?.pgNumber || TF?.pgNumber == 0) && TF?.pgSize)
      paramsValues = `?PgNumber=${TF?.pgNumber}&PgSize=${TF?.pgSize}`;
    return this.http.get<TServiceResult<PageList<AddedBookModel>>>(`${this.apiUrl}/GetUserAddedBooks/${paramsValues}`);
  }

  transferBookToOtherAuthor(book?: transferBookModel): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(`${this.apiUrl}/ChangeAuthorOfBook`, book);
  }

  getRateByWorkId(bookId: string): Observable<TServiceResult<workItemRateModel>> {
    return this.http.get<TServiceResult<workItemRateModel>>(`${this.apiUrl}/GetWorkRate/${bookId}`);
  }

  getByPublisherId(publisherId: string, searchFilter?: SearchFilterModel): Observable<TServiceResult<PageList<BookModel>>> {
    return this.http.post<TServiceResult<PageList<BookModel>>>(`${this.apiUrl}/GetByPublisherId/${publisherId}`, searchFilter);
  }

  CreateBook(body: AddedBookDetailModel): Observable<TServiceResult<IAddedBookResponse>> {
    return this.http.post<TServiceResult<IAddedBookResponse>>(`${this.apiUrl}/Create`, body);
  }

  getWithRequestIncluded(id: string): Observable<TServiceResult<BookModel>> {
    return this.http.get<TServiceResult<BookModel>>(`${this.apiUrl}/GetWithRequestIncluded/${id}`)
  }

  updateBook(book: BookRequestModel): Observable<TServiceResult<UpdateBookResult>> {
    return this.http.put<TServiceResult<UpdateBookResult>>(`${this.apiUrl}/Update`, book);
  }

}
